import { rrdBaseConfig } from "./environment.base-rrd";
// Environment config for the rrd production environment
rrdBaseConfig.production = true;
rrdBaseConfig.rollbar.enabled = true;
rrdBaseConfig.rollbar.environment = "rrd";
rrdBaseConfig.displayUncaughtErrorMessage = false;
export const environment = rrdBaseConfig;
